const baseURL = '/api/'; // on production here will be just valid path
export const isProduction = process.env.REACT_APP_ENV === 'production';
export const buildNo = process.env.REACT_APP_BUILD_NO;
console.log(process.env.REACT_APP_BUILD_NO);
export {baseURL};


// WEBPACK FOOTER //
// ./src/config.ts